export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/translation.0279a58.svg";